<cft-dialog *transloco="let t" [title]="t('shareModal.header.title')">
  <cft-dialog-content>
    <div>
      <h2 class="text-center heading-2xl">{{ title }}</h2>
      <h3 class="mt-xs text-center text-base font-normal">{{ plot }}</h3>
    </div>
    <div class="mt-xl flex flex-col flex-wrap justify-center gap-y-lg sm:mx-xl sm:mb-2xl sm:flex-row sm:gap-xl">
      <div class="inline-flex cursor-pointer flex-col" (click)="shareViaSms()">
        <div class="inline-flex justify-center rounded-lg bg-[#00BA77] p-md text-white sm:items-center sm:p-xl">
          <fa-icon class="px-2xs drop-shadow-xl heading-xl" [icon]="faMessage"></fa-icon>
          <span class="ml-xs inline-flex items-center font-medium sm:hidden">{{ t('shareModal.viaSms') }}</span>
        </div>
        <p class="ml-xs hidden text-center sm:block">SMS</p>
      </div>
      <div class="inline-flex cursor-pointer flex-col" (click)="shareViaMail()">
        <div class="inline-flex items-center justify-center rounded-lg bg-[#4D9FEB] p-md text-white sm:p-xl">
          <fa-icon class="px-2xs drop-shadow-xl heading-xl" [icon]="faEnvelope"></fa-icon>
          <span class="ml-xs inline-flex items-center font-medium sm:hidden">{{ t('shareModal.viaEmail') }}</span>
        </div>
        <p class="mt-xs hidden text-center sm:block">E-Mail</p>
      </div>
      <div class="inline-flex cursor-pointer flex-col" (click)="shareViaWhatsapp()">
        <div class="inline-flex items-center justify-center rounded-lg bg-[#65D072] p-md text-white sm:p-xl">
          <fa-icon class="px-[5.5px] drop-shadow-xl heading-xl" [icon]="faWhatsapp"></fa-icon>
          <span class="ml-xs inline-flex items-center font-medium sm:hidden">{{ t('shareModal.viaWhatsapp') }}</span>
        </div>
        <p class="mt-xs hidden text-center sm:block">WhatsApp</p>
      </div>
      <div class="inline-flex cursor-pointer flex-col" (click)="copyToClipboard()">
        <div class="inline-flex items-center justify-center rounded-lg bg-[#989898] p-md text-white sm:p-xl">
          <fa-icon class="px-[5.5px] drop-shadow-xl heading-xl" [icon]="faCopy"></fa-icon>
          <span class="ml-xs inline-flex items-center font-medium sm:hidden">{{ t('shareModal.copyLink') }}</span>
        </div>
        <p class="mt-xs hidden text-center sm:block">{{ t('shareModal.copyLink') }}</p>
      </div>
    </div>
  </cft-dialog-content>
</cft-dialog>
